// import React from 'react';
// import FeatureCard from '../../../../styles/FeatureCard.js';

// import agent from '../../../../assets/services/backup/icons/security.png';
// import AP from '../../../../assets/services/backup/icons/securityserviceportal.png';
// import HW from '../../../../assets/services/backup/icons/efficientbackup.png';
// import self from '../../../../assets/services/backup/icons/affordablecloud.png';
// import efficientStorage from '../../../../assets/services/backup/icons/multisecurelocs.png';
// import WO from '../../../../assets/services/backup/icons/completeprotection.png';
// import EA from '../../../../assets/services/backup/icons/backupsupport.png';

// const Cards = () => {
//   return (
//     <div className="disastercards disastercards-padding my-0 my-md-4">
//       <div className="disastercards-row">
//         <FeatureCard image={agent} title="Security" description="It doesn't matter how well you have protected your primary systems, if your backup systems present an easy target for attackers. Our solution integrates data protection with threat-agnostic cybersecurity, enabling unique interactions like the scanning of backups for malware and ensuring that you’ll always have clean and accessible copies of business-critical data. END to END Encryption: In-Flight and Data-At-Rest Encryption. AI-based anti-malware, Ransomware protection.
// AI-based Ransomware protection." />
//         <FeatureCard image={AP} title="Self-service portal" description="The self-service panel is a web-based control panel that allows admins to manage virtual objects, such as virtual machines, volumes, and virtual networks, in isolated administrative environments
// In this you can manage and supervise all your company Backups with easy self-service portal. The same self-service portal can be used to manage Server/End-point device Anti-Virus protection, Patch management and disaster recovery.
// " />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard image={HW} title="Direct Backup to Public Clouds" description="No additional gateway or complex setup is required, just connect your storage endpoint, apply your protection plan, and start backing up. It gives businesses the freedom to back up data directly to any public or private S3-compatible storage including Amazon S3, etc. Direct backup to Microsoft Azure Storage is available. It is Ideal for hybrid and multicloud. Incremental and differential backups, retention policies, notarization and granular recovery." />
//         <FeatureCard image={self} title="Affordable Cloud Backup Storage Pricing" description="Smarter backups with clear, predictable costs. Cloud Backup Storage as low as $0.025 per GB with no Ingress & Egress charges (only charged for the storage consumed after deep compression). Our cloud backup service offers cost-efficient, usage-based pricing designed for businesses. Storage is billed only on the actual data stored after advanced compression and deduplication, helping you significantly reduce backup footprints and overall spend." />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard image={efficientStorage} title="Multi Secure Geo Locations" description="We at Synectiks aim for 3-2-1 rule of Thumb to protect the Data, which implies that it should always have three copies of your data, that you keep it backed up on at least two different types of storage media, and with at least one copy of the data offsite. Synectiks has different backup Secure Geo locations with different power grids to make sure your data is available when disaster strikes in one location." />
//         <FeatureCard image={WO} title="Complete protection for 20+ platforms" description="Streamline your data protection with a single, unified solution that supports more than 20 platforms and workloads across physical, virtual, cloud, and SaaS environments. Protect Windows and Linux servers and VMs, eight major hypervisors, PCs and Macs, iOS and Android mobile devices, and critical business applications including Microsoft on-premises workloads, SAP HANA, and Oracle Database.
// The platform also secures Microsoft 365 (Office 365), Google Workspace (G Suite), and websites, enabling consistent backup,  and management from one centralized console.
// " />
//       </div>

//       <div className="disastercards-row">
//         <FeatureCard image={EA} title="Support" description="Our Follow-the-Sun support model ensures round-the-clock backup monitoring and assistance, with dedicated onshore and offshore teams working seamlessly across time zones.
// This guarantees continuous oversight of backup jobs, replication status, storage utilization, and recovery points, ensuring issues are detected and resolved proactively. our teams are available 24/7/365 to provide rapid response, guided recovery, and operational support—so your data remains protected, recoverable, and compliant at all times.
// " />
//       </div>


//     </div>
//   );
// };

// export default Cards;


















import React from 'react';
import '../../../../styles/disasterCard.css'; // Ensure CSS is imported
import FeatureCard from '../../../../styles/FeatureCard.js';

// Import your images...
import agent from '../../../../assets/services/backup/icons/security.png';
import AP from '../../../../assets/services/backup/icons/securityserviceportal.png';
import HW from '../../../../assets/services/backup/icons/efficientbackup.png';
import self from '../../../../assets/services/backup/icons/affordablecloud.png';
import efficientStorage from '../../../../assets/services/backup/icons/multisecurelocs.png';
import WO from '../../../../assets/services/backup/icons/completeprotection.png';


const Cards = () => {
  const cardData = [
    {
      image: agent,
      title: "Security",
      description: (
        <>
          <p>
            It doesn't matter how well you have protected your primary systems if your backup systems present an easy target for attackers. Our solution integrates data protection with threat-agnostic cybersecurity, enabling unique interactions like the scanning of backups for malware and ensuring that you’ll always have clean and accessible copies of business-critical data.
          </p>
          <p>
            <strong>END to END Encryption:</strong> In-Flight and Data-At-Rest Encryption. Includes AI-based anti-malware and Ransomware protection.
          </p>
        </>
      )
    },
    {
      image: AP,
      title: "Self-service portal",
      description: (
        <>
          <p>
            The self-service panel is a web-based control panel that allows admins to manage virtual objects, such as virtual machines, volumes, and virtual networks, in isolated administrative environments.
          </p>
          <p>
            You can manage and supervise all your company backups with this easy self-service portal. The same portal can be used to manage Server/End-point device Anti-Virus protection, Patch management, and Disaster recovery.
          </p>
        </>
      )
    },
    {
      image: HW,
      title: "Direct Backup to Public Clouds",
      description: (
        <>
          <p>
            No additional gateway or complex setup is required, just connect your storage endpoint, apply your protection plan, and start backing up. It gives businesses the freedom to back up data directly to any public or private S3-compatible storage, including Amazon S3 and Microsoft Azure Storage.
          </p>
          <p>
            Ideal for hybrid and multicloud environments. Features incremental and differential backups, retention policies, notarization, and granular recovery.
          </p>
        </>
      )
    },
    {
      image: self,
      title: "Affordable Cloud Backup Storage Pricing",
      description: (
        <>
          <p>
            Smarter backups with clear, predictable costs. Cloud Backup Storage as low as $0.025 per GB with no Ingress & Egress charges (only charged for the storage consumed after deep compression).
          </p>
          <p>
            Our cloud backup service offers cost-efficient, usage-based pricing designed for businesses. Storage is billed only on the actual data stored after advanced compression and deduplication, helping you significantly reduce backup footprints and overall spend.
          </p>
        </>
      )
    },
    {
      image: efficientStorage,
      title: "Multi Secure Geo Locations",
      description: (
        <>
          <p>
            We at Synectiks aim for the <strong>3-2-1 rule of thumb</strong> to protect data, which implies that you should always have three copies of your data, backed up on at least two different types of storage media, with at least one copy offsite.
          </p>
          <p>
            Synectiks has different secure geo-locations with independent power grids to make sure your data is available even when disaster strikes in one location.
          </p>
        </>
      )
    },
    {
      image: WO,
      title: "Complete protection for 20+ platforms",
      description: (
        <>
          <p>
            Streamline your data protection with a single, unified solution that supports more than 20 platforms and workloads across physical, virtual, cloud, and SaaS environments.
          </p>
          <p>
            Protect Windows and Linux servers and VMs, eight major hypervisors, PCs and Macs, iOS and Android mobile devices, and critical business applications including Microsoft on-premises workloads, SAP HANA, and Oracle Database. The platform also secures Microsoft 365, Google Workspace, and websites from one centralized console.
          </p>
        </>
      )
    },
    // {
    //   image: EA,
    //   title: "Support",
    //   description: (
    //     <>
    //       <p>
    //         Our <strong>Follow-the-Sun</strong> support model ensures round-the-clock backup monitoring and assistance, with dedicated onshore and offshore teams working seamlessly across time zones.
    //       </p>
    //       <p>
    //         This guarantees continuous oversight of backup jobs, replication status, storage utilization, and recovery points. Our teams are available 24/7/365 to provide rapid response, guided recovery, and operational support—so your data remains protected, recoverable, and compliant at all times.
    //       </p>
    //     </>
    //   )
    // }
  ];

  return (
    <div className="disastercards-section">
      <div className="disastercards-grid">
        {cardData.map((card, index) => (
          <FeatureCard
            key={index}
            image={card.image}
            title={card.title}
            description={card.description}
            centered={true} // Forces Center Alignment
          />
        ))}
      </div>
    </div>
  );
};

export default Cards;